/** Shared canvas drawing for Challenges lobby idle tips. */

export type ChallengeLobbyTipDraw = {
  text: string;
  posX: number;
  posY: number;
};

export type ChallengeLobbyTipAnchor = {
  x: number;
  y: number;
  size: number;
};

export function drawChallengeLobbyTipText(
  ctx: CanvasRenderingContext2D,
  tip: ChallengeLobbyTipDraw,
  opts: {
    square: ChallengeLobbyTipAnchor;
    alpha?: number;
    color?: string;
    shadowColor?: string;
  },
) {
  const text = String(tip.text || "").trim();
  if (!text) return;
  const relX = Math.min(4, Math.max(-3, Number(tip.posX) || 0));
  const relY = Math.min(4, Math.max(-3, Number(tip.posY) || 0));
  const x = opts.square.x + relX * opts.square.size;
  const y = opts.square.y + relY * opts.square.size;
  const alpha = opts?.alpha ?? 1;
  const color = opts?.color || "#ffffff";
  const fontSize = Math.max(12, Math.floor(opts.square.size * 0.16));
  ctx.save();
  ctx.globalAlpha = Math.max(0, Math.min(1, alpha));
  ctx.font = `700 ${fontSize}px "Segoe UI", system-ui, sans-serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillStyle = color;
  ctx.shadowColor = opts.shadowColor || "rgba(180, 230, 255, 0.85)";
  ctx.shadowBlur = Math.max(8, fontSize * 0.7);
  const maxW = opts.square.size * 3.9;
  const words = text.split(/\s+/);
  const lines: string[] = [];
  let line = "";
  for (const word of words) {
    const next = line ? `${line} ${word}` : word;
    if (ctx.measureText(next).width > maxW && line) {
      lines.push(line);
      line = word;
    } else {
      line = next;
    }
  }
  if (line) lines.push(line);
  const lineH = fontSize * 1.25;
  const startY = y - ((lines.length - 1) * lineH) / 2;
  for (let i = 0; i < lines.length; i++) {
    ctx.fillText(lines[i]!, x, startY + i * lineH);
  }
  ctx.restore();
}
